import { render, staticRenderFns } from "./inviter.vue?vue&type=template&id=51503dc8&scoped=true&"
import script from "./inviter.vue?vue&type=script&lang=js&"
export * from "./inviter.vue?vue&type=script&lang=js&"
import style0 from "./inviter.vue?vue&type=style&index=0&id=51503dc8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51503dc8",
  null
  
)

export default component.exports